/* eslint-disable */
const getCookieDomain = () => {
  try {
    const hostParts = location.hostname.split('.');
    if (hostParts.indexOf('localhost') > -1) { // local
      return '';
    } if (hostParts.indexOf('dev') > -1) { // dev environment
      return `; domain=.${hostParts.slice(hostParts.indexOf('dev')).join('.')}`;
    } if (hostParts.length > 2) { // prod environment
      return `; domain=.${hostParts.slice(hostParts.length - 2).join('.')}`;
    }
    return '';
  } catch (error) {
    console.log('getCookieDomain error: ', error);
  }
};

const deleteCookie = (cname) => {
  const d = new Date();
  d.setTime(d.getTime() + (-365 * 10 * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  const domain = getCookieDomain();
  document.cookie = `${cname}=; ${expires}; path=/${domain}`;
};

export default deleteCookie;
